import { CreateNewAccountModal } from "./CreateNewAccountModal";

export default CreateNewAccountModal;
